import { Controller } from "stimulus";
import moment from 'moment';

export default class extends Controller {

  static targets = [
    "raceDropDown"
  ];

  connect(){
    console.log(this.identifier);
  }

  changeOption(e) {
    const url = e.target.value;
    Turbolinks.visit(url);
  }
}
